import { render, staticRenderFns } from "./ContratoModalEditar.vue?vue&type=template&id=85787998&"
import script from "./ContratoModalEditar.vue?vue&type=script&lang=ts&"
export * from "./ContratoModalEditar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('85787998', component.options)
    } else {
      api.reload('85787998', component.options)
    }
    module.hot.accept("./ContratoModalEditar.vue?vue&type=template&id=85787998&", function () {
      api.rerender('85787998', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/Contratos/ContratoModalEditar.vue"
export default component.exports